export const GET_PROMPT_ANALYSES = 'GET_PROMPT_ANALYSES';
export const GET_PROMPT_ANALYSIS_USAGE = 'GET_PROMPT_ANALYSIS_USAGE';
